/**
 * The contact profile is persisted to localStorage and was otherwise only ever
 * written at login, so a session started before a profile change kept stale
 * data indefinitely — including newly added fields such as `is_portal_admin`,
 * which decide what the portal offers. Refresh it once per app start.
 *
 * Deliberately not awaited: the pages render from the stored profile and pick
 * up the refreshed values reactively.
 */
export default defineNuxtPlugin(() => {
  const userStore = useUserStore()

  if (!userStore.isLoggedInAsContact) return

  userStore.fetchContactProfile()
})
